/* eslint-disable local-rules/ordered-imports */
// @ts-strict-ignore
import './utils/honeycomb_observability';

import * as React from 'react';
import ReactDOM from 'react-dom/client';
import {RouterProvider} from 'react-router-dom';
import {getAppRouter} from '#iron/routes/router';

document.addEventListener(`DOMContentLoaded`, () => {
  const appContainer = document.getElementById(`mixpanel-app-wrapper`);
  const root = ReactDOM.createRoot(appContainer);
  root.render(<RouterProvider router={getAppRouter()} />);
});
